import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, useContext } from 'react';
import { createPortal } from 'react-dom';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { FixedButtonContainerProviderContext } from '../FixedButtonContainerProvider/FixedButtonContainerProvider';
import styles from './FixedButton.module.css';
export enum FixedButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}
export type FixedButtonProps = Omit<ComponentProps<'button'>, 'type'> & {
  type?: FixedButtonType;
};
export const FixedButton: FunctionComponent<FixedButtonProps> = React.memo(props => {
  const $ = _c(8);
  const {
    type: t0,
    children,
    className,
    ...remainingProps
  } = prepareProps({
    props
  });
  const type = t0 === undefined ? FixedButtonType.Primary : t0;
  const context = useContext(FixedButtonContainerProviderContext);
  if (!context.containerElement) {
    throw new Error("No containerElement in the FixedButtonContainerProviderContext found. Did you forget to wrap your components with a FixedButtonContainerProviderContext?");
  }
  const t1 = createPortal;
  const t2 = "button";
  const t3 = classes(className, styles.button, buttonTypeToClassName[type]);
  let t4;
  if ($[0] !== children || $[1] !== remainingProps || $[2] !== t3) {
    t4 = <button type={t2} {...remainingProps} className={t3}>{children}</button>;
    $[0] = children;
    $[1] = remainingProps;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== context.containerElement || $[5] !== t1 || $[6] !== t4) {
    t5 = t1(t4, context.containerElement);
    $[4] = context.containerElement;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
});
const buttonTypeToClassName: Record<FixedButtonType, string | null> = {
  primary: styles.buttonPrimary,
  secondary: styles.buttonSecondary
};